import groq from 'groq';

export const blockSectionFields = groq``;
